
export default {
    $vm: null
};
